import { createApi } from '@reduxjs/toolkit/query/react';
import { urls } from '../../utils/helpers/ApiClient';
import axiosFetchBase from '../axiosFetchBase';

export const erasmusConsortiumApi = createApi({
  reducerPath: 'erasmusConsortiumApi',
  keepUnusedDataFor: 0,
  baseQuery: axiosFetchBase,
  endpoints: (builder) => ({
    getErasmusConsortiums: builder.query({
      query: (isEnglish = false) => {
        return {
          url: urls.erasmusConsortiums,
        };
      },
    }),
    getErasmusConsortium: builder.query({
      query: (id) => ({
        url: urls.erasmusConsortiumDetail(id),
      }),
    }),
    saveErasmusConsortium: builder.mutation({
      query(req) {
        if (req.id) {
          return {
            url: urls.erasmusConsortiumDetail(req.id),
            method: 'PUT',
            data: req.body,
          };
        } else {
          return {
            url: urls.erasmusConsortiums,
            method: 'POST',
            data: req.body,
          };
        }
      },
    }),
    deleteErasmusConsortium: builder.mutation({
      query(id) {
        return {
          url: urls.erasmusConsortiumDetail(id),
          method: 'DELETE',
        };
      },
    }),
    saveErasmusConsortiumUniversities: builder.mutation({
      query(req) {
        return {
          url: urls.createConsortiumsUniversities,
          method: 'POST',
          data: req,
        };
      },
    }),
    deleteErasmusConsortiumUniversity: builder.mutation({
      query(req) {
        return {
          url: urls.deleteConsortiumsUniversities(req),
          method: 'POST',
          data: req,
        };
      },
    }),
  }),
});

export const {
  useGetErasmusConsortiumsQuery,
  useGetErasmusConsortiumQuery,
  useSaveErasmusConsortiumMutation,
  useDeleteErasmusConsortiumMutation,
  useSaveErasmusConsortiumUniversitiesMutation,
  useDeleteErasmusConsortiumUniversityMutation,
} = erasmusConsortiumApi;
